import { MultiInput as GammaMultiInput } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type MultiInputProps = React.ComponentProps<typeof GammaMultiInput>

type Props = Omit<MultiInputProps, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
}

const MultiInput: React.FC<Props> = ({ missingLabel, ...props }) => (
  <GammaMultiInput
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
  />
)

export default MultiInput
